import { FeatureType, TerrainType } from "./types.js";
/**
 * GameHex wraps a IHex and provides convenient APIs for accessing hex data.
 */
export class GameHex {
    constructor(hexData) {
        this.hexData = hexData;
    }
    /**
     * Get the x coordinate of this hex
     */
    get x() {
        return this.hexData.x;
    }
    /**
     * Get the y coordinate of this hex
     */
    get y() {
        return this.hexData.y;
    }
    /**
     * Get the terrain type of this hex
     */
    get terrain() {
        if (!this.hexData.terrain) {
            return TerrainType.NONE;
        }
        return this.hexData.terrain;
    }
    /**
     * Get the feature type of this hex
     */
    get feature() {
        if (!this.hexData.feature) {
            return FeatureType.NONE;
        }
        return this.hexData.feature;
    }
    /**
     * Get river edges as a bitflag
     */
    get rivers() {
        return this.hexData.rivers;
    }
    /**
     * Get road edges as a bitflag
     */
    get roads() {
        return this.hexData.roads;
    }
    /**
     * Get the underlying HexDTO
     */
    toDTO() {
        return this.hexData;
    }
}
